/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { displayMessage, postAPI, getAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import { Space, Button, Card, Popconfirm, Layout, Table, Input } from "antd";
import {
  ALL_DYNAMIC_CONTENT,
  DELETE_DYNAMIC_CONTENT,
} from "../../constants/api";
import { getDyPageTypeLabel } from "../../constants/constent";

function PagesTable() {
  const { Content } = Layout;
  const [state, setState] = useState([]);
  const [filteredState, setFilteredState] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();

  useLayoutEffect(() => {
    getList();
  }, []);

  const getList = () => {
    setLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        const formattedData = data["data"].map((row, index) => ({
          key: index,
          ID: index + 1,
          Title: row.title,
          Type: getDyPageTypeLabel(row.type),
          Action: (
            <Space>
              <Button
                onClick={() => {
                  navigate("/pages/edit/" + row.id);
                }}
                block
              >
                Edit
              </Button>
              <Popconfirm
                title="Delete the task"
                description="Are you sure to delete this task?"
                onConfirm={() => deleteData(row.id)}
                okText="Yes"
                cancelText="No"
              >
                <Button danger>Delete</Button>
              </Popconfirm>
            </Space>
          ),
        }));
        setState(formattedData);
        setFilteredState(formattedData); // Set filtered state initially to all items
      } else {
        setState([]);
        setLoading(false);
      }
    };
    const errorFn = function () {
      setState([]);
      setLoading(false);
    };
    getAPI(ALL_DYNAMIC_CONTENT, successFn, errorFn, {});
  };

  const deleteData = (values) => {
    setLoading(true);
    let data = {
      id: values,
    };
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        getList();
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Delete Data");
    };
    postAPI(DELETE_DYNAMIC_CONTENT, data, successFn, errorFn);
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = state.filter(
      (row) =>
        row.Title.toLowerCase().includes(value.toLowerCase()) ||
        row.Type.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredState(filtered);
  };

  const columns = [
    {
      title: "Sno",
      dataIndex: "ID",
      width: 50,
    },
    {
      title: "Type",
      dataIndex: "Type",
      width: 50,
    },
    {
      title: "Title",
      dataIndex: "Title",
      width: 150,
    },
    {
      title: "Action",
      dataIndex: "Action",
      width: 100,
    },
  ];

  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Card
            title="Manage Pages"
            extra={
              <Space>
                <Input
                  placeholder="Search by Title or Type"
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                  style={{ width: 300 }}
                />
                <Button onClick={() => navigate("/pages/add")}>
                  Add <PlusOutlined />
                </Button>
              </Space>
            }
            bordered={true}
          >
            <Table
              loading={loading}
              columns={columns}
              dataSource={filteredState}
              pagination={{ pageSize: 10 }}
              scroll={{ x: 240 }}
            />
          </Card>
        </Content>
        <LayoutFooter />
      </Layout>
    </>
  );
}

export default PagesTable;
